import type { FC, ReactNode } from 'react'

import { ArrowUpRight, Linkedin } from 'lucide-react'
import { SectionHeading } from '@/components/landing/section-heading'
import { TEAM } from '@/constants/content'

export const TeamSection: FC = (): ReactNode => {
    return (
        <section
            id='team'
            aria-labelledby='team-title'
            className='py-24 sm:py-28'
        >
            <div className='mx-auto grid max-w-6xl gap-12 px-6 lg:grid-cols-12 lg:gap-16'>
                <SectionHeading
                    titleId='team-title'
                    eyebrow='Team'
                    title='Bauerfahrung trifft Produktentwicklung.'
                    description='ConcreTrack ist ein Produkt der BBA GmbH aus Bad Saarow. Hinter der Messung stehen Menschen, die Baustellen kennen und die Plattform selbst entwickeln.'
                    className='lg:col-span-4'
                />

                <ul className='grid gap-5 sm:grid-cols-2 lg:col-span-8'>
                    {TEAM.map((member) => (
                        <li
                            key={member.name}
                            className='reveal flex flex-col rounded-[1.75rem] border border-border bg-card p-7'
                        >
                            <div className='flex items-center gap-4'>
                                <span
                                    aria-hidden='true'
                                    className='flex size-16 shrink-0 items-center justify-center rounded-2xl bg-ink text-xl font-light tracking-[0.06em] text-ink-foreground'
                                >
                                    {member.initials}
                                </span>

                                <div>
                                    <h3 className='text-lg font-medium leading-snug text-foreground'>
                                        {member.name}
                                    </h3>

                                    <p className='mt-1 font-mono text-[0.66rem] font-medium uppercase tracking-[0.16em] text-primary'>
                                        {member.role}
                                    </p>
                                </div>
                            </div>

                            <p className='mt-6 text-pretty leading-relaxed text-muted-foreground'>
                                {member.text}
                            </p>

                            <div className='mt-6 border-t border-border pt-6'>
                                <p className='font-mono text-[0.64rem] font-medium uppercase tracking-[0.16em] text-muted-foreground'>
                                    Verantwortlich für
                                </p>

                                <ul className='mt-3 flex flex-wrap gap-2'>
                                    {member.focus.map((item) => (
                                        <li
                                            key={item}
                                            className='rounded-full border border-border bg-background/60 px-3 py-1 text-sm text-foreground/85'
                                        >
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <a
                                href={member.linkedin}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='group mt-auto inline-flex w-fit items-center gap-2 pt-7 text-sm font-medium text-foreground transition-colors hover:text-primary'
                            >
                                <Linkedin className='size-4 text-primary' aria-hidden='true' />
                                LinkedIn-Profil
                                <span className='sr-only'>von {member.name} (öffnet in neuem Tab)</span>
                                <ArrowUpRight className='size-3.5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5' aria-hidden='true' />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
